export class PeriodoPlanilla {
  idperiodo?: number;
  anio?: number;
  mes?: number;
  fecha_inicio?: string;
  fecha_fin?: string;
  tipo?: string;
  estado?: number;
  estado_nombre?: string;
  idsucursal?: number;
  sucursal_nombre?: string;
  editando?: boolean;
  constructor() { this.tipo = 'mensual'; }
}
